import {
  differenceInCalendarDays,
  differenceInCalendarWeeks,
  format,
} from "date-fns"
import type { TFunction } from "i18next"
import i18n from "@/lib/i18n/i18n"
import { getDateFnsLocale, getIntlLocale } from "@/lib/i18n/format"
import { RouteStop } from "@/reducers/routes2gSlice"

// `t` is the caller's, so a memoised chat card re-renders on a switch.
const relativeTimeLabel = (
  timestamp: string | undefined,
  t: TFunction = i18n.t,
) => {
  if (!timestamp) return ""

  const now = new Date()
  const date = new Date(timestamp)

  if (differenceInCalendarDays(now, date) === 0) {
    return date.toTimeString().slice(0, 5)
  }

  if (differenceInCalendarDays(now, date) === 1) {
    return t("common.yesterday")
  }

  if (differenceInCalendarWeeks(now, date, { weekStartsOn: 1 }) === 0) {
    return format(date, "EEEE", { locale: getDateFnsLocale() })
  }

  return date.toLocaleDateString(getIntlLocale())
}

const formatStopDistance = (stop: RouteStop, t: TFunction = i18n.t): string => {
  if (stop.proximity_status === "arrived") return t("chat.chatCard.arrived")
  if (stop.proximity_status === "arriving") return t("chat.chatCard.arriving")
  if (stop.remaining_distance && stop.remaining_distance >= 1000) {
    return `${Math.floor(stop.remaining_distance / 1000).toString()} km`
  } else if (stop.remaining_distance) {
    return `${stop.remaining_distance} m`
  }
  return ""
}

export { relativeTimeLabel, formatStopDistance }
